import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { BACKEND_URL } from "constants";
import { Modal, Image, OverlayTrigger, Tooltip } from "react-bootstrap";

const PhotoThumbnail = ({
  src,
  photoId,
  className = "",
  thumbnailClass = "thumbnail",
  fetchHighResOnMount = false,
}) => {
  const [show, setShow] = useState(false);
  const [displaySrc, setDisplaySrc] = useState(src);
  const [original, setOriginal] = useState(null);

  const fetchHighResImage = useCallback(
    (onSuccess) => {
      const payload = { photo_ids: [photoId] };

      axios
        .post(BACKEND_URL + "/photos/by_id", payload)
        .then((response) => {
          const photos = response.data;
          if (photos?.[0] && photos[0]["photo"] !== "") {
            const highResPhoto = `data:image/jpeg;base64,${photos[0]["photo"]}`;
            onSuccess(highResPhoto);
          } else {
            onSuccess(src);
          }
        })
        .catch((e) => {
          console.error("Failed to fetch high res photo:", e);
          onSuccess(src);
        });
    },
    [photoId, src]
  );

  useEffect(() => {
    setDisplaySrc(src);

    if (fetchHighResOnMount && photoId) {
      fetchHighResImage((highResPhoto) => {
        setDisplaySrc(highResPhoto);
        setOriginal(highResPhoto);
      });
    }
  }, [src, photoId, fetchHighResOnMount, fetchHighResImage]);

  const handleZoom = () => {
    if (original) {
      setShow(true);
    } else {
      fetchHighResImage((highResPhoto) => {
        setOriginal(highResPhoto);
        setShow(true);
      });
    }
  };

  const tooltip = (
    <Tooltip id="zoom-in" style={{ position: "fixed" }}>
      <strong>Zoom</strong>
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger placement="top" overlay={tooltip}>
        <Image
          className={`${thumbnailClass} ${className}`.trim()}
          src={displaySrc}
          alt="Photo thumbnail"
          onClick={handleZoom}
          style={{ cursor: "pointer" }}
        />
      </OverlayTrigger>

      <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
        <Modal.Body className="d-flex justify-content-center align-items-center">
          <Image
            src={original || displaySrc}
            alt="Full-size photo"
            className="img-fluid"
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhotoThumbnail;